import { Box, Link, Typography, useMediaQuery } from "@mui/material";
import { APP_CONSTANTS } from "@utils/constants";
import logo_footer from "../../../assets/images/main/footer_logo.svg";
import logo from "../../../assets/images/main/logo_huge.svg";
import leaf from "../../../assets/images/main/mask_group.webp";
import DownloadAppButton from "./common/DownloadAppButton";
import StartTheQuizButton from "./common/StartTheQuizButton";
import TermsAndConditions from "./common/TermsAndConditions";

function Footer() {
  const isMobile = useMediaQuery("(max-width:1030px)");
  const isLess1175 = useMediaQuery("(max-width:1175px)");

  return (
    <Box
      sx={{
        backgroundColor: "#112417",
        padding: "60px 20px 40px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
        }}
      >
        {!isMobile && (
          <img width={242} height={412} src={leaf} alt="leaf"></img>
        )}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            maxWidth: "536px",
          }}
        >
          <img width={isMobile ? 75 : 120} src={logo} alt="logo"></img>

          <Typography
            sx={{
              textAlign: "center",
              fontFamily: "Avenir600",
              fontSize: isMobile ? "24px" : "40px",
              color: "#FFF",
              lineHeight: "normal",
              margin: isMobile ? "20px 0" : "30px 0",
            }}
          >
            The time is now to transform your relationship with alcohol for good
          </Typography>
          <Box
            sx={{
              width: isMobile ? "100%" : "320px",
            }}
          >
            <StartTheQuizButton />
          </Box>

          <Typography
            sx={{
              textAlign: "center",
              fontFamily: "Avenir400",
              fontSize: "16px",
              color: "#728879",
              lineHeight: "normal",
              marginTop: isMobile ? "20px" : "30px",
            }}
          >
            Complete a brief questionnaire so we can create a personalized plan
            tailored to you
          </Typography>
        </Box>
        {!isMobile && (
          <img
            style={{ transform: "scaleX(-1)" }}
            width={242}
            height={412}
            src={leaf}
            alt="leaf"
          ></img>
        )}
      </Box>
      <Box
        sx={{
          height: "1px",
          width: "100%",
          background: "#1E3927",
          margin: isMobile ? "60px 0 40px" : "100px 0 40px",
        }}
      ></Box>
      {isMobile ? (
        <Box>
          <TermsAndConditions isMainScreen />
          <Box
            sx={{
              margin: "20px 0",
            }}
          >
            <DownloadAppButton />
          </Box>
          <Typography
            sx={{
              textAlign: "center",
              fontFamily: "Avenir400",
              fontSize: "14px",
              color: "#728879",
              lineHeight: "normal",
            }}
          >
            {APP_CONSTANTS.APP_NAME} by {APP_CONSTANTS.COMPANY_NAME} ©{" "}
            {new Date().getFullYear()} | {APP_CONSTANTS.ADDRESS},{" "}
            <Link
              sx={{
                fontFamily: "Avenir400",
                fontSize: "14px",
                color: "#728879",
                lineHeight: "normal",
                textDecorationColor: "#728879",
              }}
              href={`mailto:${APP_CONSTANTS.EMAIL}`}
              className="link"
              target="_blank"
            >
              {APP_CONSTANTS.EMAIL}
            </Link>
          </Typography>
          <Box
            sx={{
              display: "flex",
              marginTop: "20px",
              justifyContent: "center",
            }}
          >
            <img
              width={263}
              src="/refuse/svg/payments.svg"
              alt="payments"
            ></img>
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            gap: "40px",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              width: "100%",
            }}
          >
            <img width={138} src={logo_footer} alt="logo"></img>
            <Box
              sx={{
                display: "flex",
                gap: "20px",
                flexDirection: !isLess1175 ? "row" : "column-reverse",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Avenir400",
                  fontSize: "14px",
                  color: "#728879",
                  lineHeight: "normal",
                  maxWidth: "390px",
                }}
              >
                {APP_CONSTANTS.APP_NAME} by {APP_CONSTANTS.COMPANY_NAME} ©{" "}
                {new Date().getFullYear()}| {APP_CONSTANTS.ADDRESS},{" "}
                <Link
                  sx={{
                    fontFamily: "Avenir400",
                    fontSize: "14px",
                    color: "#728879",
                    lineHeight: "normal",
                    textDecorationColor: "#728879",
                  }}
                  href={`mailto:${APP_CONSTANTS.EMAIL}`}
                  className="link"
                  target="_blank"
                >
                  {APP_CONSTANTS.EMAIL}
                </Link>
              </Typography>
              <img
                width={263}
                src="/refuse/svg/payments.svg"
                alt="payments"
              ></img>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              alignItems: "flex-end",
            }}
          >
            <Box
              sx={{
                "& .download_app_btn": {
                  width: "155px",
                  height: "46px",
                },
              }}
            >
              <DownloadAppButton />
            </Box>
            <TermsAndConditions isMainScreen />
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default Footer;
